import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Skeleton from 'react-loading-skeleton'
import ConfirmPopup from './../modal/modal';
import ManagementTable from "./../tables/managementTable";
import { boolToYesNo, getCurrencies, getUnits, stripHTML, setConfig, getConfig, getYesNo, getLocalizedCountryFromCurrency } from "../../utils"
import cloneDeep from 'lodash/cloneDeep';


const ClientsAdmin = () => {

    let navigate = useNavigate();
    const { clientsStore,utilsStore } = useStores();
    const { getAll, clients, remove, duplicate, getAllWithOptions, } = clientsStore;
    const { getCurrencies, currencies } = utilsStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);

    /*useEffect(() => {
        setIsLoading(true);
        async function fetchMyAPI() {
            getAll().then(() => {
                setIsLoading(false);
            });
        }

        fetchMyAPI();
    }, [getAll]);*/
    /**useEffect(() => {
        alert(templates?.results?.length?.toString())
    }, [templates?.results])*/

    useEffect(() => {
        Promise.all([getCurrencies()]);
    }, []);

    const onPageChange = (props) => {
        var newProps = cloneDeep(props);

        newProps.filterBy?.filters?.forEach(main => {
            main?.filters?.forEach(f => {
                /*if (["workUnit", "billingUnit", "salaryUnit"].indexOf(f.field) > -1) {
                    f.value = getUnitOptions()?.find(x => x.text == f.value)?.value;
                }*/

            });
        });
        setIsLoading(true);
        getAllWithOptions(newProps/*props.page + 1, props.filter, props.sort*/).then(() => {
            setIsLoading(false);
        });
    }

    return (
        <ManagementTable name={t('clients')} ref={tableRef} isLoading={isLoading}
            /*filters={["name","currency","company"]}
            onDelete={(id) => {
                remove(id).then(() => { tableRef?.current?.resetPage() })
            }}*/
            /*onEdit={(id) => {
                alert(id)
            }}*/
            config={{
                size: getConfig("clients", "size"),
                dataState: getConfig("clients", "dataState")
            }}
            onColumnSizeChange={(c) => setConfig("clients", "size", c)}
            onDataStateChange={(c) => { setConfig("clients", "dataState", c) }}


            items={clients?.results} onPageChange={onPageChange} pageCount={clients?.pageCount} total={clients?.count} pageSize={clients?.pageSize} columns={
                [
                    { name: "clientName", prop: "name" },
                    {
                        name: "currency", fn: (v) => v.shortName ? `${v.shortName} - ${getLocalizedCountryFromCurrency(v)}` : "-", filterSelectOptions: currencies?.map((x) => ({
                            value: x.id.toString(), text: `${x.shortName} - ${getLocalizedCountryFromCurrency(x)}`
                        }))
                    },
                    { name: "company", fn: (v) => v?.name ?? "-"}

                ]}
            extraButtons={
                [
                    { text: t('edit'), icon: solid("pen-to-square"), onClick: (id) => { navigate(`./${id}`) } },
                    { text: t('copy'), icon: solid("copy"), onClick: (id) => { duplicate(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmCopy"), modalTitle: t("copy") },
                    { text: t('delete'), icon: solid("trash"), onClick: (id) => { remove(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmDelete"), modalTitle: t("delete"), danger: true }
                ]
            }
        />

    );


};

export default observer(ClientsAdmin);
